<template>
    <div class="qydh">
        <div style="height: 38px;">
            <van-tabs v-model="active" @click="onClick" class="selectTab">
                <van-tab :title="cat.catName" v-for="(cat,index) in list" :key="index"/>
            </van-tabs>
        </div>
        <div class="container" :style="{height:height}">
            <swiper :options="swiperOption" :autoplay="false">
                <swiper-slide v-for=" (item,index) in plusList" :key="index">
                    <div class="goodsItem" @click="toKt(item)">
                        <img :src="item.imgUrl" class="spu-img"/>
                        <div class="btnitem">
                            <div class="gm-btn">
                                    <span class="jg-btn">¥{{item.sellingPrice}}
                                        <span class="spu-yj">¥{{item.originalPrice}}</span>
                                    </span>
                                <span class="kt-btn">立即开通</span>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";
    import 'swiper/dist/css/swiper.css'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'

    export default {
        components: {
            swiper,
            swiperSlide,
        },
        data() {
            return {
                deptId: '',
                deptName: '',
                list: [],
                plusList: [],
                active: 0,
                height: '',

                swiperOption: {
                    pagination: {
                        el: '.swiper-pagination', // 与slot="pagination"处 class 一致
                        clickable: false, // 轮播按钮支持点击
                    },
                    speed: 500,
                    // 循环
                    loop: false,
                    spaceBetween: 10, // 轮播图左右间距
                    slidesPerView: 1.7, // 一屏显示的slide个数，图片宽度
                    centeredSlides: true, // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
                }
            };
        },
        async created() {
            let height = window.innerWidth / 1.55
            this.height = height + 'px'
            this.deptId = getDeptId()
            this.getStyleCats()
        },
        props: {
            item: Object
        },
        methods: {
            handleClick() {

            },
            onClick(val) {
                let cat = this.list[val]
                this.getPlusList(cat)
            },

            toKt(item) {
                this.$router.push('/plusDetails/' + this.deptId + '/' + item.id)
            },

            async getStyleCats() {
                let data = {
                    styleId: this.item.id
                }
                let res = await this.$get("/spm/getSpmStyleCats", data)
                this.list = res.list
                if (res.list.length > 0) {
                    let cat = res.list[0]
                    this.getPlusList(cat)
                }
            },

            async getPlusList(cat) {
                let data = {
                    deptId: this.deptId,
                    catId: cat.id,
                }
                let res = await this.$get("/spm/getSpmPlusList", data)
                this.plusList = res.list
            },
            onSearch() {

            },
        },
    };
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;

        .swiper-container {
            width: 100%;

            .swiper-slide {
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                transition: 300ms;
                transform: scale(0.8); //小图缩放比例
                overflow: hidden;
            }

            .swiper-slide-active,
            .swiper-slide-duplicate-active {
                transform: scale(1);
            }
        }
    }

    .qydh {
        padding-bottom: 35px;
    }

    .selectTab /deep/ .van-tabs--line {
        height: 33px;
    }

    .selectTab /deep/ .van-tabs__wrap {
        height: 33px;
    }

    .selectTab /deep/ .van-tab--active {
        color: #323233;
        font-weight: 500;
        font-size: 14px;
        width: 100px;
    }

    .goodsItem {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        border: #e5e5e5 solid 3px;
    }

    .btnitem {
        height: 46px;
    }

    .spu-yj {
        text-decoration: line-through;
        color: #888888;
        font-size: 10px;
        margin-left: 5px;
    }

    .gm-btn {
        position: relative;
        transform: translate(-50%, -50%); /* 补偿自身的宽高的一半 */
        left: 50%;
        top: 23px;
        height: 25px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .jg-btn {
        height: 25px;
        line-height: 25px;
        font-size: 10px;
        width: 115px;
        background-color: #DBBB88;
        text-align: center;
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
        color: #FFFFFF;
        background: linear-gradient(-68deg, transparent 15px, #DBBB88 0) right;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-right: -12px;
    }

    .kt-btn {
        height: 25px;
        line-height: 25px;
        font-size: 10px;
        width: 75px;
        padding-left: 8px;
        background-color: #3F4141;
        text-align: center;
        border-top-right-radius: 18px;
        border-bottom-right-radius: 18px;
        color: #C5A87A;
        background: linear-gradient(110deg, transparent 15px, #3F4141 0) left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-left: -12px;
    }


</style>
